// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconBottle = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M15 1H9v3.378a9 9 0 01-.776 3.655l-.276.622A11 11 0 007 13.122V21a2 2 0 002 2h6a2 2 0 002-2v-7.878a11 11 0 00-.948-4.467l-.276-.622A9 9 0 0115 4.378zm-4 3.378V3h2v1.378a11 11 0 00.948 4.467l.276.622q.33.746.522 1.533H11v8h4v2H9v-7.878a9 9 0 01.776-3.655l.276-.622A11 11 0 0011 4.378M13 17h2v-4h-2z"
    />
  );
export default SvgIconBottle;
